import React, {useEffect} from "react";
import {connect} from "react-redux";
import {useNavigate} from "react-router-dom";

import {select, AppState} from "../../store";
import {AdminLayout} from "../../atoms/admin-layout";
import {UserDetail} from "../../store/users/usersModel";
import {Facilities} from "../../models/types/AdmissionForm";
import {AdminPccActivityLogsTableContainer} from "./AdminPccActivityLogsTableContainer";
import {useFacilitySettingsParams} from "../page-admin-facility-settings/hooks/useFacilitySettingsParams";

type Props = Readonly<{
  user: UserDetail;
  facilities: Facilities;
}>;

const PageAdminActivityLogRenderer = ({facilities, user}: Props) => {
  const navigate = useNavigate();
  const {facilityId} = useFacilitySettingsParams();

  useEffect(() => {
    if (facilityId === "_") {
      navigate("/admin/facility/_/facility-settings");
    }
  }, [facilityId, navigate]);

  return (
    <AdminLayout>
      <AdminPccActivityLogsTableContainer
        facilities={facilities}
        facilityId={facilityId}
      />
    </AdminLayout>
  );
};

const mapStateToProps = (state: AppState) => ({
  // Reside admins can open the activity log of an inactive facility from its settings page
  facilities: select.adminSession.allFacilities(state),
  user: select.adminSession.user(state),
});

export const PageAdminActivityLog = connect(mapStateToProps)(
  PageAdminActivityLogRenderer,
);
